import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Pdc } from 'src/app/shared/models/pdc';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-edition-pdc',
  standalone: false,
  templateUrl: './edition-pdc.component.html',
  styleUrl: './edition-pdc.component.scss'
})


export class EditionPdcComponent {


  constructor(
    private modalService: NgbModal,

    private paramService: ParameterService,
    private messageService: MessageService,
    private ActionServiceService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage:LocalStorageService


  ) {

  }

  ngOnInit() {
    this.items = this.localStorage.getPdcProjet();
    //console.log("this.items",this.items);
    

    this.item = this.items;
  }

  close() {

    this.modalService.dismissAll();
  }

  item: Pdc = new Pdc();
  programmeData: any = []
  agenceData: any = [];
  resultatItems: any = [];
  fileName: string = '';
  items:any;

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.item.photo = file;

    }
  }
  editPdc() {

    // if (!this.item.canSend()) {
    //   this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });

    // } else {


      const formData = new FormData();
     formData.append('titre_projet', this.item.titre_projet);
      formData.append('description_projet', this.item.description_projet);
      formData.append('nom_bailleur', this.item.nom_bailleur);
      formData.append('lien_article', this.item.lien_article);
      formData.append('photo', this.item.photo);
      this.ngxService.start();
      this.paramService.editPdc(formData, this.items.reference).subscribe(
        (response: any) => {
          ////console.log("la reponse du webservice",response);

          this.modalService.dismissAll();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
          this.ActionServiceService.notifySeriviceCreated();
          this.ngxService.stop();
        },
        (error: any) => {
          ////console.log("une erreur est survenu",error);
          //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error });
          this.ActionServiceService.notifySeriviceCreated();
          this.ngxService.stop();


        }
      )
    //}

  }


}